interface PageHandle {
	readonly page: string;
}

interface RouteMatchWithUnknownHandle {
	readonly handle: unknown;
}

export function hasPageHandle<TRouteMatch extends RouteMatchWithUnknownHandle>(
	routeMatch: TRouteMatch,
): routeMatch is TRouteMatch & { readonly handle: PageHandle } {
	return (
		typeof routeMatch.handle === 'object' &&
		routeMatch.handle !== null &&
		'page' in routeMatch.handle &&
		typeof routeMatch.handle.page === 'string'
	);
}
